(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // SVG icon constant to avoid repetition
  const CART_ICON_SVG = `<svg class="pa-card-cart-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="9" cy="21" r="1"></circle>
    <circle cx="20" cy="21" r="1"></circle>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
  </svg>`;

  // Global cart state management
  const PACartState = {
    cache: null,
    listeners: new Set(),

    async fetch(force = false) {
      if (this.cache && !force) return this.cache;
      try {
        const res = await fetch('/cart.js');
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        this.cache = await res.json();
        return this.cache;
      } catch (err) {
        console.error('Error fetching cart:', err);
        return { items: [], item_count: 0, total_price: 0 };
      }
    },

    async update(force = true) {
      const cart = await this.fetch(force);
      this.notify(cart);
      return cart;
    },

    notify(cart) {
      this.listeners.forEach((callback) => callback(cart));
    },

    subscribe(callback) {
      this.listeners.add(callback);
      return () => this.listeners.delete(callback);
    },
  };

  function initPACartForms(scope = document) {
    const productForms = scope.querySelectorAll('.new-product-form');

    function debounce(fn, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
      };
    }

    function showCartToast(message = 'Added to Cart!') {
      let toast = document.querySelector('.cart-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'cart-toast';
        document.body.appendChild(toast);
      }

      toast.textContent = message;

      toast.classList.remove('show');
      void toast.offsetWidth;
      toast.classList.add('show');

      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => {
          if (toast) toast.remove();
        }, 300);
      }, 2500);
    }

    function updateCartBubble(count) {
      const topCount = document.querySelector('.lhdr__cart-count');
      if (topCount) topCount.textContent = count;

      const drawerCount = document.querySelector('.lhdr__drawer-cart-count');
      if (drawerCount) {
        drawerCount.textContent = count;
        drawerCount.hidden = count === 0;
      }
    }

    function notifyCartUpdate(cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      PACartState.cache = cart;
      PACartState.notify(cart);
    }

    // -------- CUSTOM QUANTITY (card only) --------
    function showQuantityInput(container, variantId, addBtn, quantity = 1) {
      const oldQty = container.querySelector('.card-quantity');
      if (oldQty) oldQty.remove();

      const qtyEl = document.createElement('div');
      qtyEl.className = 'card-quantity';
      qtyEl.innerHTML = `
          <button class="quantity__button" name="minus" type="button">-</button>
          <input class="quantity__input" type="number" min="0" value="${quantity}">
          <button class="quantity__button" name="plus" type="button">+</button>
        `;

      addBtn.insertAdjacentElement('afterend', qtyEl);

      const minusBtn = qtyEl.querySelector('[name="minus"]');
      const plusBtn = qtyEl.querySelector('[name="plus"]');
      const input = qtyEl.querySelector('.quantity__input');

      async function updateCartQuantity(newQty) {
        if (newQty < 0) newQty = 0;
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ updates: { [variantId]: newQty } }),
          });
          const cart = await res.json();
          input.value = newQty;
          updateCartBubble(cart.item_count);
          notifyCartUpdate(cart);

          if (newQty <= 0) {
            qtyEl.remove();
            if (addBtn) addBtn.style.display = 'flex';
          }
        } catch (err) {
          console.error('Cart update error:', err);
        }
      }

      minusBtn.addEventListener('click', () => updateCartQuantity(parseInt(input.value) - 1));
      plusBtn.addEventListener('click', () => updateCartQuantity(parseInt(input.value) + 1));
      input.addEventListener(
        'change',
        debounce(() => updateCartQuantity(parseInt(input.value) || 0), 300)
      );
    }

    // -------- BIND CUSTOM FORMS --------
    productForms.forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';

      const variants = JSON.parse(form.dataset.variants);
      const variantInput = form.querySelector("input[name='id'], select[name='id']");
      const addBtn = form.querySelector('.atc-btn');
      const variantTabs = form.querySelectorAll('.variant-tab');
      const sectionId = form.dataset.sectionId;
      const productId = form.dataset.productId;

      let productContainer = form.querySelector(`#CardInfo-${sectionId}-${productId}`);
      if (!productContainer) {
        productContainer = document.querySelector(`#CardInfo-${sectionId}-${productId}`);
      }

      const regularPriceEl = productContainer?.querySelector('.pa-card-price .price-text');

      let selectedOptions = [];

      function updateVariant(variant) {
        if (!variant) return;
        if (variantInput) {
          variantInput.value = variant.id;
        }
        addBtn.disabled = !variant.available;
        addBtn.innerHTML = variant.available ? `${CART_ICON_SVG} Add to cart` : 'Sold out';
        if (regularPriceEl) {
          regularPriceEl.textContent = (variant.price / 100).toLocaleString('en-IN', {
            maximumFractionDigits: 0,
          });
        }
      }

      // Init variant
      const currentVariant = variants.find((v) => v.id == variantInput?.value) || variants[0];
      if (currentVariant) {
        selectedOptions = [...currentVariant.options];
        form.querySelectorAll('.variant-tab').forEach((button) => button.classList.remove('active'));
        currentVariant.options.forEach((opt, i) => {
          form.querySelector(`.variant-tab[data-option-index="${i + 1}"][data-value="${opt}"]`)?.classList.add('active');
        });
        updateVariant(currentVariant);
      }

      // Variant switch
      variantTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          if (tab.classList.contains('disabled')) return;
          const optionIndex = parseInt(tab.dataset.optionIndex) - 1;
          selectedOptions[optionIndex] = tab.dataset.value;

          tab.parentElement.querySelectorAll('.variant-tab').forEach((sib) => sib.classList.remove('active'));
          tab.classList.add('active');

          const matchedVariant = variants.find((v) => v.options.every((opt, i) => selectedOptions[i] === opt));
          updateVariant(matchedVariant);

          if (matchedVariant) {
            syncFormWithCart(matchedVariant.id);
          }
        });
      });

      // Sync form UI with cart state
      function syncFormWithCart(variantId) {
        const cart = PACartState.cache;
        if (!cart) return;

        const lineItem = cart.items.find((item) => item.variant_id == variantId);

        if (lineItem) {
          addBtn.style.display = 'none';
          const existingQty = form.querySelector('.card-quantity');
          if (existingQty) {
            const input = existingQty.querySelector('.quantity__input');
            if (input && parseInt(input.value) !== lineItem.quantity) {
              input.value = lineItem.quantity;
            }
          } else {
            showQuantityInput(form, lineItem.variant_id, addBtn, lineItem.quantity);
          }
        } else {
          const oldQty = form.querySelector('.card-quantity');
          if (oldQty) oldQty.remove();
          addBtn.style.display = 'flex';
        }
      }

      // Add to cart
      addBtn.addEventListener('click', async () => {
        const variantId = variantInput?.value;
        if (!variantId) return alert('Please select a variant first');

        const selectedVariant = variants.find((v) => v.id == variantId);
        if (!selectedVariant || !selectedVariant.available) {
          return alert('Please select an available variant');
        }

        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          const addedItem = await res.json();

          addBtn.disabled = false;
          addBtn.innerHTML = `${CART_ICON_SVG} Add to cart`;
          addBtn.style.display = 'none';
          showQuantityInput(form, addedItem.variant_id, addBtn, addedItem.quantity);
          showCartToast('Added to Cart!');

          const cart = await PACartState.update(true);
          updateCartBubble(cart.item_count);
        } catch (err) {
          console.error(err);
          addBtn.disabled = false;
          addBtn.innerHTML = `${CART_ICON_SVG} Add to cart`;
        }
      });

      // On load: check if already in cart
      PACartState.fetch().then((cart) => {
        const lineItem = cart.items.find((item) => item.variant_id == variantInput?.value);
        if (lineItem) {
          addBtn.style.display = 'none';
          showQuantityInput(form, lineItem.variant_id, addBtn, lineItem.quantity);
        }
        updateCartBubble(cart.item_count);
      });

      // Subscribe to cart updates (event-driven)
      const unsubscribe = PACartState.subscribe((cart) => {
        const currentVariantId = parseInt(variantInput?.value);
        syncFormWithCart(currentVariantId);
        updateCartBubble(cart.item_count);
      });

      // Cleanup subscription when form is removed
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.removedNodes.forEach((node) => {
            if (node === form || (node.contains && node.contains(form))) {
              unsubscribe();
              observer.disconnect();
            }
          });
        });
      });

      if (form.parentElement) {
        observer.observe(form.parentElement, { childList: true, subtree: true });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initPACartForms();

    // Watch for cards added/replaced via AJAX filtering or section morphing
    const gridObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.new-product-form')) {
            initPACartForms(node.parentElement || document);
          } else if (node.querySelector && node.querySelector('.new-product-form')) {
            initPACartForms(node);
          }
        });
      });
    });

    gridObserver.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initPACartForms(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
